import React from 'react';

export const MenuContext = React.createContext(null);



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/MenuContext.js